// extracted by mini-css-extract-plugin
module.exports =  {"acceptedSpan":"handshake_utils-module_acceptedSpan_f73b3","rejectedSpan":"handshake_utils-module_rejectedSpan_ab1ab","revokeButton":"handshake_utils-module_revokeButton_c45a6"};